<template>
    <div>
        <div class="items">
            <el-collapse class="formset__list">
                <div v-for="item, i in form.items" class="formset__item">
                    <el-collapse-item :name="i">
                        <template slot="title">
                            <formset-header :label="getHeaderLabel(item)"
                                            :items.sync="form.items"
                                            :errors="checkForErrors(errors.items, [i])"
                                            :index="i"/>
                        </template>
                        <el-form-item label="Typ"
                                      :error="errors.items && errors.items[i] && errors.items[i].item_type">
                            <el-select v-model="item.item_type"
                                       @change="typeChanged(item)"
                                       placeholder="Wybierz typ breadcrumba">
                                <el-option
                                        v-for="item in types"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Tytuł"
                                      v-if="item.item_type"
                                      :error="errors.items && errors.items[i] && errors.items[i][addLanguageSuffix('title')]">
                            <el-input v-model="item[addLanguageSuffix('title')]">
                            </el-input>
                        </el-form-item>
                        <link-component v-model="item.link"
                                        v-if="item.item_type === 'link'"
                                        :key="item.key || item.id"
                                        :errors="errors.items && errors.items[i] && errors.items[i]['link']">
                        </link-component>
                    </el-collapse-item>
                </div>
            </el-collapse>
            <el-button @click="addSection"
                       type="primary" class="fluid">
                Dodaj breadcrumb
            </el-button>
        </div>
    </div>
</template>
<script>
    import uniqueId from 'lodash.uniqueid'
    import {Tag} from '@/api'

    export default {
        props: ['form', 'errors'],
        data () {
            return {
                types: [
                    {value: 'link', label: 'Link'},
                    {value: 'title', label: 'Tekst'},
                ]
            }
        },
        methods: {
            getHeaderLabel (item) {
                if (item.item_type === undefined) {
                    return 'Nowy breadcrumb'
                } else if (item.item_type === 'link') {
                    return 'Link'
                } else if (item.item_type === 'title') {
                    return `Tekst ${item.title_pl || ''}`
                }
            },
            addSection () {
                const blankObject = {
                    key: uniqueId(),
                    link: {}
                }
                if (!Array.isArray(this.form.items)) {
                    this.$emit('update:form', {
                        ...this.form,
                        items: [
                            blankObject
                        ]
                    })
                } else {
                    this.form.items.push(blankObject)
                }
            },
            typeChanged (item) {
                if (item.item_type === 'title') {
                    item.link = null
                }
            }
        },
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// BreadcrumbsWidget.vue?15b79362